import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppLayoutComponent, NotificationComponent } from './ui';
import { AuthService } from './auth/services/auth.service';
import { CommonModule } from '@angular/common';
import { AppService } from './app.service';
import { ModalService } from './ui/modal/modal.service';
import { MunicipalitySelectorModalComponent } from './municipality-selector-modal/municipality-selector-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NotificationComponent,
    AppLayoutComponent,
  ],
  template: `
    <app-notification />
    <ng-container *ngIf="shouldShowLayout(); else publicContent">
      <app-layout [appName]="'Smienk Connect'"></app-layout>
    </ng-container>
    <!-- Show direct content for public routes -->
    <ng-template #publicContent>
      <router-outlet></router-outlet>
    </ng-template>
  `,
})
export class AppComponent implements OnInit {
  appService = inject(AppService);
  municipalityId = this.appService.municipalityId;
  authService = inject(AuthService);
  modalService = inject(ModalService);

  constructor() {}

  ngOnInit() {
    if (this.authService.isAuthenticated() && this.shouldShowLayout()) {
      this.authService.getUser().subscribe((user) => {
        const municipalities = user.municipalities ?? [];
        if (municipalities.length > 1) {
          this.modalService.open(MunicipalitySelectorModalComponent);
        } else if (municipalities.length === 1) {
          this.appService.setCurrentMunicipalityId(municipalities[0].id);
        }
      });
    }
  }

  shouldShowLayout(): boolean {
    // Get the current path
    const path = window.location.pathname;

    // List of public routes that should be shown outside the layout
    const publicRoutes = ['/callback', '/login'];

    // Show layout only if authenticated and not on a public route
    return (
      this.authService.isAuthenticated() &&
      !publicRoutes.some((route) => path.startsWith(route))
    );
  }
}
